// import moment from 'moment';
// import 'moment/locale/ru';

// Use global appConfig
declare let appConfig: any;

import json from './ru.json';

// Save loaded json to global config object
appConfig.localeDictionary = json;

/* flatpickr localization */
appConfig.flatpickrDictionary = {
    firstDayOfWeek: 1, // Monday
    weekdays: {
        shorthand: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
    },
    months: {
        shorthand: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
    }
};
